module.exports = __webpack_public_path__ + "static/media/icon-social-organic.2a39e7ab.svg";